define.alias("ember-power-select/components/power-select/options", "preview-grid/components/power-select/options");